module.exports = "<!--The content below is only a placeholder and can be replaced.-->\n\n<app-sidenav-list></app-sidenav-list>\n"